// @ts-check
import clsx from 'clsx'
import styles from './Section.module.css'

/**
 * @typedef {{
 *   children: import('react').ReactNode,
 *   fullWidth?: boolean,
 *   spaceY?: boolean,
 *   className?: string,
 * }} Props
 */

/** @param {Props} props */
export default function Section({ children, fullWidth = false, spaceY = false, className = '' }) {
  return (
    <section
      className={clsx(styles.section, className, {
        [styles.sectionFullWidth]: fullWidth,
        [styles.spaceY]: spaceY,
      })}
    >
      {children}
    </section>
  )
}
